import { PositionEmploymentStatus } from 'src/api';
import type { SelectFieldOption } from 'src/types/components';

export const EMPLOYEE_SEARCH_CATEGORY_MAP = {
  ssn: 'ssn',
  employeeId: 'employeeId',
  name: 'name',
  email: 'email',
  phone: 'phone',
} as const;

export const EMPLOYEE_SEARCH_CATEGORIES = [
  { label: 'SSN', value: EMPLOYEE_SEARCH_CATEGORY_MAP.ssn },
  { label: 'Employee ID', value: EMPLOYEE_SEARCH_CATEGORY_MAP.employeeId },
  { label: 'Name', value: EMPLOYEE_SEARCH_CATEGORY_MAP.name },
  { label: 'Email', value: EMPLOYEE_SEARCH_CATEGORY_MAP.email },
  { label: 'Phone', value: EMPLOYEE_SEARCH_CATEGORY_MAP.phone },
] as const satisfies SelectFieldOption[];

export const EMPLOYMENT_STATUS_TO_LABEL = {
  [PositionEmploymentStatus.Active]: 'Active',
  [PositionEmploymentStatus.Fmla]: 'FMLA',
  [PositionEmploymentStatus.Inactive]: 'Inactive',
  [PositionEmploymentStatus.Ifmla]: 'IFMLA',
  [PositionEmploymentStatus.OnLeave]: 'On Leave',
  [PositionEmploymentStatus.Deceased]: 'Deceased',
  [PositionEmploymentStatus.Retired]: 'Retired',
  [PositionEmploymentStatus.Separated]: 'Separated',
  [PositionEmploymentStatus.Terminated]: 'Terminated',
  [PositionEmploymentStatus.TemporarilyInactive]: 'Temporarily_Inactive',
  [PositionEmploymentStatus.SeveredWithPay]: 'Severed With Pay',
  [PositionEmploymentStatus.Intern]: 'Intern',
} as const satisfies Record<PositionEmploymentStatus, string>;
